'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';

const COUNSEL_DOT_CHAR = '●';

export interface CounselSlotIndicatorDotProps {
  variant: 'dot';
  size?: number;
}

export interface CounselSlotIndicatorCountProps {
  variant: 'count';
  count: number;
  isMobile?: boolean;
}

export type CounselSlotIndicatorProps =
  | CounselSlotIndicatorDotProps
  | CounselSlotIndicatorCountProps;

/**
 * 상담 배정 슬롯 표시 컴포넌트.
 * - dot: 슬롯 그리드 등에서 "상담 있음" 단일 점
 * - count: 캘린더/범례에서 상담 건수 ● 표시 (5건=주황, 나머지=파랑)
 */
export function CounselSlotIndicator(props: CounselSlotIndicatorProps): React.ReactElement | null {
  if (props.variant === 'dot') {
    const size = props.size ?? 6;
    return (
      <Box
        component="span"
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: 'warning.main',
          display: 'inline-block',
          flexShrink: 0,
        }}
      />
    );
  }

  if (props.variant === 'count' && props.count > 0) {
    const fontSize = props.isMobile ? '0.5rem' : '0.6rem';
    return (
      <Box
        component="span"
        sx={{
          display: 'flex',
          gap: 0.25,
          flexWrap: 'wrap',
          alignItems: 'center',
          lineHeight: 1.2,
        }}
      >
        <Typography component="span" sx={{ fontSize, color: 'warning.main' }}>
          {COUNSEL_DOT_CHAR.repeat(Math.floor(props.count / 5))}
        </Typography>
        <Typography component="span" sx={{ fontSize, color: 'primary.main' }}>
          {COUNSEL_DOT_CHAR.repeat(props.count % 5)}
        </Typography>
      </Box>
    );
  }

  return null;
}
